import { Cell } from './Cell.js'

export function LongsColumn() {
  return (
    <div className="flex flex-col gap-3 h-full">
      <Cell cell="long_x10" />
      <Cell cell="long_x25" />
      <Cell cell="long_x50" />
    </div>
  )
}
